var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 11.4523 4.45228 11 5 11C5.54772 11 6 11.4523 6 12C6 12.5477 5.54772 13 5 13C4.45228 13 4 12.5477 4 12Z",
    stroke: "#3E444A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12C18 11.4523 18.4523 11 19 11C19.5477 11 20 11.4523 20 12C20 12.5477 19.5477 13 19 13C18.4523 13 18 12.5477 18 12Z",
    stroke: "#3E444A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12C11 11.4523 11.4523 11 12 11C12.5477 11 13 11.4523 13 12C13 12.5477 12.5477 13 12 13C11.4523 13 11 12.5477 11 12Z",
    stroke: "#3E444A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.41887944fde61febc9f25f59bd544d8c.svg";
export { ForwardRef as ReactComponent };